var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.65,
    y: 37.957,
    transform: "matrix(0.7752 0.6317 -0.6317 0.7752 34.6859 3.3343)",
    fill: "#282D33",
    width: 4.016,
    height: 24.889
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.65,
    y: 48.275,
    transform: "matrix(0.6317 0.7752 -0.7752 0.6317 81.4248 -70.8212)",
    fill: "#282D33",
    width: 25.194,
    height: 4.017
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "124.772,127.782 3.228,127.782 3.228,58.583 7.244,58.583 7.244,123.766 120.756,123.766  120.756,58.583 124.772,58.583  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.263,
    y: 86.905,
    transform: "matrix(0.6717 0.7408 -0.7408 0.6717 89.571 19.068)",
    fill: "#282D33",
    width: 4.015,
    height: 47.389
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 81.035,
    y: 108.592,
    transform: "matrix(0.7409 0.6716 -0.6716 0.7409 101.4137 -41.6815)",
    fill: "#282D33",
    width: 47.388,
    height: 4.015
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M87.802,95.657H40.199L19.11,74.101V0h89.782v74.101L87.802,95.657z M41.889,91.642h44.225l18.764-19.179 V4.017H23.126v68.446L41.889,91.642z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M64.548,72.013c-13.063,0-23.688-10.549-23.688-23.516c0-12.964,10.626-23.512,23.688-23.512 c7.128,0,13.807,3.139,18.324,8.612l-3.097,2.558c-3.753-4.547-9.303-7.153-15.228-7.153c-10.848,0-19.673,8.745-19.673,19.495 c0,10.752,8.825,19.5,19.673,19.5c4.328,0,8.431-1.364,11.864-3.944l2.412,3.212C74.689,70.37,69.753,72.013,64.548,72.013z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M60.633,60.049C60.632,60.049,60.633,60.049,60.633,60.049c-0.929,0-1.912-0.146-2.922-0.434 c-3.041-0.869-5.34-3.394-6.148-6.754c-1.09-4.524,0.594-9.536,4.392-13.079c3.325-3.098,7.857-3.748,11.076-3.748 c2.697,0,4.714,0.449,4.798,0.469l2.114,0.478l-0.636,2.071c-0.161,0.52-3.928,12.771-4.598,14.684 C67.321,57.688,64.302,60.049,60.633,60.049z M67.03,40.051c-2.497,0-5.97,0.463-8.338,2.669 c-3.275,3.056-3.814,6.757-3.226,9.201c0.473,1.963,1.692,3.36,3.347,3.832c0.65,0.186,1.263,0.28,1.819,0.28 c2.49,0,3.705-1.973,4.285-3.628c0.477-1.356,2.703-8.549,3.855-12.282C68.254,40.081,67.664,40.051,67.03,40.051z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M73.686,59.837c-2.044,0-3.935-0.698-5.44-2.057c-3.11-2.806-0.969-12.295,0.584-17.701l3.859,1.108 c-1.72,5.996-2.536,12.504-1.713,13.653c1.489,1.338,3.39,1.078,4.712,0.617c3.032-1.055,6.506-4.528,7.283-9.13 c0.561-3.326-0.098-8.342-6.423-13.344l2.49-3.15c8.282,6.55,8.5,13.564,7.893,17.163c-0.93,5.506-5.01,10.545-9.923,12.255 C75.88,59.644,74.762,59.837,73.686,59.837z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "86.428,95.657 41.573,95.657 4.743,60.165 7.529,57.273 43.193,91.642 84.808,91.642  120.472,57.273 123.259,60.165  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3cb9bf85d095b6a6bd11833d1c1f9cc4.svg";
export { ForwardRef as ReactComponent };